import { Country } from 'shared/types/types'

export const masks = {
  [Country.RU]: '999 999-99-99',
  [Country.KZ]: '999 999-99-99',
  [Country.UZ]: '99 999 9999',
  [Country.BY]: '99 999-99-99',
  [Country.AM]: '99 999999',
  [Country.KG]: '999 999999',
  [Country.GE]: '99 999 9999',
  [Country.TJ]: '99 999 9999',
  [Country.TM]: '99 99 99-99',
}

export const masksForFullPhone = {
  [Country.RU]: `+9 ${masks.RU}`,
  [Country.KZ]: `+9 ${masks.KZ}`,
  [Country.AM]: `+999 ${masks.AM}`,
  [Country.BY]: `+999 ${masks.BY}`,
  [Country.UZ]: `+999 ${masks.UZ}`,
  [Country.KG]: `+996 ${masks.KG}`,
  [Country.GE]: `+995 ${masks.KG}`,
  [Country.TJ]: `+992 ${masks.KG}`,
  [Country.TM]: `+993 ${masks.KG}`,
}

export const phonePrefix = {
  [Country.RU]: '7',
  [Country.KZ]: '7',
  [Country.AM]: '374',
  [Country.BY]: '375',
  [Country.UZ]: '998',
  [Country.KG]: '996',
  [Country.GE]: '995',
  [Country.TJ]: '992',
  [Country.TM]: '993',
}
